import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { SalesOrderService } from "../../../services/salesOrder.service";
import { MenuMappingService } from "../../../services/menuMapping.service";
import { PrintData } from "../../master/print/print";
// import { style } from "@angular/core/src/animation/dsl";

@Component({
  selector: "addEditInvoice",
  templateUrl: "./openOrderConvertion.html",
})
export class openOrderConvertion {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  rawdata:any;
  seasonList: any;
  widthList: any[];
  designGroupList : any[];
  execApi: boolean = true;
  menu : any;
  scanned_by : any;
  invoicedata: any = {
    rate_type: "",
    invoice_type: "",
    corcharge: 0,
    boxless: 0,
    taxper: 5,
    disper: 0,
    salesorder: false,
    rate: 0,
    no_of_bundles: 0,
    remarks: '',
    narration: '',
    sf_36: 0,
    sf_38: 0,
    sf_40: 0,
    sf_42: 0,
    sf_44: 0,
    sf_46: 0,
    sh_36: 0,
    sh_38: 0,
    sh_40: 0,
    sh_42: 0,
    sh_44: 0,
    sh_46: 0,
    bf_36: 0,
    bf_38: 0,
    bf_40: 0,
    bf_42: 0,
    bf_44: 0,
    bf_46: 0,
    bh_36: 0,
    bh_38: 0,
    bh_40: 0,
    bh_42: 0,
    bh_44: 0,
    bh_46: 0
  };
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  invoiceTypeList = ["ESTIMATE", "INVOICE"];
  rateTypeList = ["FLAT RATE", "DISCOUNT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  partyOrderno: any;
  order: any;
  page_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  printData;
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
 
      this._params = val;
      this.mode = val["mode"];
      this.page_type = val["sale_type"];
      // this.to_sale_type = val["to_sale_type"];
      this.saveEvent = val["data"].tabevent;
      let invoicedata = Object.assign({}, val["data"]);
   
      this.invoicedata = invoicedata;
      this.invoicedata.disper = invoicedata.disper;
      this.invoicedata.sf_36 = 0;
      this.invoicedata.sf_38 = 0;
      this.invoicedata.sf_40 = 0;
      this.invoicedata.sf_42 = 0;
      this.invoicedata.sf_44 = 0;
      this.invoicedata.sf_46 = 0;
      this.invoicedata.sh_36 = 0;
      this.invoicedata.sh_38 = 0;
      this.invoicedata.sh_40 = 0;
      this.invoicedata.sh_42 = 0;
      this.invoicedata.sh_44 = 0;
      this.invoicedata.sh_46 = 0;
      this.invoicedata.bf_36 = 0;
      this.invoicedata.bf_38 = 0;
      this.invoicedata.bf_40 = 0;
      this.invoicedata.bf_42 = 0;
      this.invoicedata.bf_44 = 0;
      this.invoicedata.bf_46 = 0;
      this.invoicedata.bh_36 = 0;
      this.invoicedata.bh_38 = 0;
      this.invoicedata.bh_40 = 0;
      this.invoicedata.bh_42 = 0;
      this.invoicedata.bh_44 = 0;
      this.invoicedata.bh_46 = 0;

      if (this.mode == "Convert") {
        this.invoicedata.mode = "Add";
      }

      if (this.mode == "Convert") {
        //  this.editInvoiceList();
        this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        //   this.oncheck(this.invoicedata.salesorder);
      }
  
    
        this.invoicedata.boxless = Number(this.invoicedata.boxless);
        this.editInvoiceList();
        this.barcodeList();
        //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.oncheck(this.invoicedata.salesorder);
      
    
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    private Salesservice: SalesOrderService,
    private MappingService : MenuMappingService,
    private modalService: BsModalService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.getSalesParty();
    this.getUserList()
    this.getSeason();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.invoicedata.sales_type = this.page_type;

    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.invoicedata.taxper = 5;
      this.invoicedata.boxless = 0;
      this.invoicedata.no_of_bundles = 0;

      this.getAutoNumber();
      //this.getAuto();
    }
    if (this.mode == "Convert") {
      // this.convertAutoNumber();

      // if (this.to_page_type == "proformaWholesale") {

      //   this.invoicedata.taxper = 0;
      // }

    }
  }
  ngAfterViewInit() {
    if (this.page_type == "retail") {
      setTimeout(() => {
        $("#invoice_type").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#partyname").focus();
      }, 100);
    }
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
  
    const selectedRow = that.data.invoiceList[ind];
    const targetBagBarcode = selectedRow.bag_barcode;
  
    // Determine rows to delete and confirmation message
    let rowsToDelete;
    let confirmMessage;
  
    if (targetBagBarcode) {
      rowsToDelete = that.data.invoiceList.filter(row => row.bag_barcode === targetBagBarcode);
      confirmMessage = `All ${rowsToDelete.length} items will be deleted for the bag (${targetBagBarcode}). Proceed with deleting this bag?`;
    } else {
      rowsToDelete = [selectedRow];
      confirmMessage = "Are you sure to delete this row?";
    }
  
    swal({
      title: confirmMessage,
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        // Remove matching rows from UI
        that.data.invoiceList = that.data.invoiceList.filter(
          row => targetBagBarcode
            ? row.bag_barcode !== targetBagBarcode
            : row !== selectedRow
        );
  
        that.calctot();
  
        // Prepare backend params
        let params: any = Object.assign({}, that.invoicedata);
        params["dcid"] = rowsToDelete[0].dcid;
        params["tabevent"] = undefined;
  
        if (targetBagBarcode) {
          params["bag_no"] = targetBagBarcode;
        } else {
          params["barcode"] = selectedRow.barcode;
        }
  
        that.isLoadMask = that.Salesservice
          .DeletecounterDC(params)
          .then(function (res: any) {
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
            } else {
              swal("ERROR", res.message, "error");
            }
          });
      },
      function (dismiss) {}
    );
  }
  
  
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.invoiceList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      trans_type: 'counterdc',
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };


    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      this.invoicedata.dc_no = res.auto_no;
    });

  }
  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
      if (this.page_type == "retail") {
        this.invoicedata.party_name = "RETAIL";
      }
      this.onSelectPartyName(this.invoicedata.party_name);
    });
  }

  getUserList(){
    this.MappingService.getUserList({}).then((res: any) => {
      this.scanned_by = res.data;
      // console.log(this.scanned_by);
      });
}

  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
      type: "invoice",
    };
    this.salesinvservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.partyCtrl.setValue(this.invoicedata["season"]);
        this.invoicedata.season = res.data.season;
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }
  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  SoStyle(ind) {
    if (this.data.invoiceList[ind].so === 'Non Ord') {
      return {
        color: "red",
        fontWeight: "800"
      };
    }
  }
  checkBarcode(code) {
    if (code && code.length == 7) {
      if (this.execApi) {
        this.execApi = false;
        let params = {
          barcode: code,
          party_id:   this.invoicedata.party_id,
          trans_type: 'counterdc'
        };
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          code = parseInt(code);
          this.data.invoiceList[i].barcode = parseInt(
            this.data.invoiceList[i].barcode
          );
          if (this.data.invoiceList[i].barcode == code) {
        
            setTimeout(() => {
              this.invoicedata.barcode = "";
              $("#code").focus();
            }, 500);

            swal({
              title: "Barcode Already Exists",
              timer: 1000,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }      
        }
         
        this.salesinvservice.checkBarcode(params).then((res: any) => {
          if (this.page_type == "estimate" || this.page_type == "wholesale") {
            if (res.data.length == 0 && res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              this.execApi = true;
              this.invoicedata.barcode = "";
              return;
            }
          }

          if (res.data.length == 0) {
            //   swal("Selected Design is invalid!");
            swal({
              title: res.message,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500,
            });
            let invalidData = {
              barcode: code,
              type: "invoice",
            };
            this.invalidList.push(invalidData);
            this.invoicedata.barcode = "";
            this.execApi = true;
            return;
          }
          if (res.data.bag_barcode) {
            swal({
              title: `Barcode is mapped to bag(${res.data.bag_barcode}). Not allowed to scan seperately.`,
              timer: 2500,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.invoicedata.barcode="";
            this.execApi = true;
            return;
          }

          //For CheckIng Damage Pcs 
     
          //For CheckIng Damage Pcs barcode

          let row = Object.assign(
            {
              f36: 0,
              f38: 0,
              f40: 0,
              f42: 0,
              f44: 0,
              f46: 0,
              h36: 0,
              h38: 0,
              h40: 0,
              h42: 0,
              h44: 0,
              h46: 0,
            },
            res.data
          );
          row[row.size.toLowerCase()] = 1;
          row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
          row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
          row.totqty = row.hqty + row.fqty;

          if (this.invoicedata.rate_type == "FLAT RATE") {
            row.rate = this.invoicedata.rate;
          }

          // this.data.invoiceList.push(row);
      

          let rowFlag = this.updateInvoiceData(row, this.invoicedata);
          if (rowFlag !== false) {
            console.log(rowFlag, "check Rowwwwwwww Flagg")
            this.data.invoiceList.push(row);
    
            this.designGroupList = this.createGroup(this.data.invoiceList);


            var bottom = document.querySelector("#salesTbody");
            setTimeout(() => {
              bottom.scrollTop = bottom.scrollHeight;
            }, 300);

            this.calcBox();
            this.calctot();
          }
          this.execApi = true;
          this.invoicedata.barcode = "";
        });

      }
    }
  }

  getBagBarcodeDetails(barcode: string) {
    if (this.execApi) {
      this.execApi = false;

      const params = {
        bag_barcode: barcode,
        party_id: this.invoicedata.party_id,
        trans_type: 'counterdc'
      };

      // Split into prefix and padded number
      let [prefix, paddedNumber] = params.bag_barcode.split('-');

      // Remove leading zeros
      let originalNumber = paddedNumber ? paddedNumber.replace(/^0+/, '') : paddedNumber;

      // Handle case like 'B3-000000' → 'B3-0'
      if (originalNumber === '') {
        originalNumber = '0';
      }

      // Combine back to short format
      let shortCode = `${prefix}-${originalNumber}`;
      params.bag_barcode = shortCode;

      this.salesinvservice.checkBarcode(params).then((res: any) => {
        if (!res.data.length) {
          swal({
            title: res.message,
            timer: 2500,
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.execApi = true;
          return;
        }

        for (let i = 0; i < res.data.length; i++) {
          const rowData = res.data[i];

          let row = Object.assign(
            {
              f36: 0,
              f38: 0,
              f40: 0,
              f42: 0,
              f44: 0,
              f46: 0,
              h36: 0,
              h38: 0,
              h40: 0,
              h42: 0,
              h44: 0,
              h46: 0,
            },
            rowData
          );
          row[row.size.toLowerCase()] = 1;
          row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
          row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
          row.totqty = row.hqty + row.fqty;

          if (this.invoicedata.rate_type == "FLAT RATE") {
            row.rate = this.invoicedata.rate;
          }

          let rowFlag = this.updateInvoiceData(row, this.invoicedata);
          if (rowFlag !== false) {
            this.data.invoiceList.push(row);

            this.designGroupList = this.createGroup(this.data.invoiceList);
          }
        }

        var bottom = document.querySelector("#salesTbody");
        setTimeout(() => {
          bottom.scrollTop = bottom.scrollHeight;
        }, 300);

        this.calcBox();
        this.calctot();

        this.execApi = true;
        this.invoicedata.bagBarcode = '';
      });
    }
  }

  updateInvoiceData(row: any, invoiceData: any) {
    // Extract size and type (F or H)
    const size = row.size;
    const sizeType = size.charAt(0); // F or H
    const sizeNumber = size.substring(1); // 36, 38, etc.

    // Dynamically construct keys
    const sfKey = `${sizeType === "F" ? "sf" : "sh"}_${sizeNumber}`;
    const fKey = `${sizeType.toLowerCase()}_${sizeNumber}`;
    const bfKey = `${sizeType === "F" ? "bf" : "bh"}_${sizeNumber}`;


    // Update `sf_*` or `sh_*` count
    if (invoiceData[sfKey] !== undefined) {
  
     

        // Update `bf_*` or `bh_*` balance if applicable
        if (invoiceData[fKey] && Number(invoiceData[fKey]) > 0) {
          
            invoiceData[sfKey] += 1;
            invoiceData[bfKey] = invoiceData[fKey] - invoiceData[sfKey];
        }
        else if(invoiceData[fKey] == '0'){
         swal("ERROR", "SIZE Not Exist In Open Order PCS !!!", "error")
         return false
        }
    }


    
}

createGroup(data : any){
  const groupedData = data.reduce((acc, item) => {
    const designId = item.design_id;
    
    // Find if the design_id already exists
    let group = acc.find(group => group.design_id === designId);
    
    if (!group) {
        // If not, create a new group and add it to accumulator
        group = {
            ...item,
            fqty: item.fqty,
            hqty: item.hqty,
            totqty: item.totqty
        };
        acc.push(group);
    } else {
        // If exists, aggregate the quantities
        group.f36 += item.f36;
        group.f38 += item.f38;
        group.f40 += item.f40;
        group.f42 += item.f42;
        group.f44 += item.f44;
        group.f46 += item.f46;
        group.h36 += item.h36;
        group.h38 += item.h38;
        group.h40 += item.h40;
        group.h42 += item.h42;
        group.h44 += item.h44;
        group.h46 += item.h46;
        group.fqty += item.fqty;
        group.hqty += item.hqty;
        group.totqty += item.totqty;
    }

    return acc;
}, []);

 return groupedData
}

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }
  bsModalRef: BsModalRef;

  onSaveDC(): void {
    if (
      (this.invoicedata.party_name == undefined ||
        this.invoicedata.season == undefined)
    ) {
      swal("Make sure that All The Entries Filled");
    } else {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["boxless"] = this.invoicedata.boxless || 0;
      params["no_of_bundles"] = this.invoicedata.no_of_bundles || 0;
      params["salesorder"] = this.invoicedata.salesorder || false;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      params["designGroupList"] = JSON.stringify(this.designGroupList);

   
      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      params["mode"] = "Add";
      params["sales_type"] = 'Open to CDC';
      if (this.invoicedata.mode == "Convert Order") {
        params["sales_type"] = 'Open to Order';
        // params["estimate_dcid"] = this.invoicedata.dcid;
       
      }
      // if (
      //   this.page_type != "retail" &&
      //   this.invoicedata.mode !== "Convert" &&
      //   this.mode !== "Restore" &&
      //   this.mode !== 'Edit' && (this.page_type != 'LimitStock' && this.page_type != 'SizewiseStock')

      // ) {
      //   let order = this.partyOrderno.filter((i) =>
      //     this.invoicedata.so_no.includes(i.so_no)
      //   );
      //   this.order = order[0]["order_type"];

      //   if (this.order == "Open Order") {
      //     params["soGrid"] = JSON.stringify(this.data.invoiceList);
      //     params["ES"] = "OPENORDERLIST";
      //     if (this.mode == "Edit") params["bl"] = JSON.stringify(this.bl);
      //   }
      // }

      let that = this;

      swal({
        title: "Are you sure to save this Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.Salesservice
          .Savecounterdcentry(params)
          .then(function (res: any) {
            if (res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              return false
            }
            else {
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
        
              } else {
                if (that.mode == "Restore") {
                  swal("Sorry! You can only restore the last invoice...");
                } else {
                  swal("ERROR", res.message, "error");
                }
              }
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }


  addCounterstock(): void {
    let params = {
      dcid: this.data.invoiceList[0].dcid
    }
    let that = this;

    swal({
      title: "Are you sure to Add Counter-Stock?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.Salesservice
        .addCounterstock(params)
        .then(function (res: any) {
          if (res.message == "Access Denied") {
            swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
            return false
          }
          else {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              if (that.mode == "Restore") {
                swal("Sorry! You can only restore the last invoice...");
              } else {
                swal("ERROR", res.message, "error");
              }
            }
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });

  }
  calcBox() {
    if (this.box == "YES") {
      this.invoicedata.boxless += 10;
    }
  }

  onSelectPartyName(name) {
    let partylist = _.filter(this.partyList, { name: name });

    if (this.mode == 'Edit') {
      return
    }
    // else if(this.mode == 'Edit'){

    // }
    else if (this.mode != "Convert") {
      // this.invoicedata.agent_id = partylist[0]["agent_id"];
      this.invoicedata.party_id = partylist[0]["genLedid"];
      this.invoicedata.disper = 0;

      // if (partylist[0]["disc_applicable"] == 'YES') {
      //   this.invoicedata.disper = partylist[0]["discount"];
      // }

      // this.invoicedata.transport = partylist[0]["transport"];
    }
    this.box = partylist[0]["boxless"];

    if (this.mode == "Add") {
      if (this.page_type == "retail") {
        $("#customer_name").focus();
      } else {
        $("#so_no").focus();
      }
    }

    let params = {
      party_id: this.invoicedata.party_id,
      party_name: name,
      season: this.invoicedata.season,
    };
    this.salesinvservice.getPartyOrderNumber(params).then((res: any) => {
      this.partyOrderno = res;
    });
  }
  // saveOpenOrderDetails(){
  //     let params: any = Object.assign({}, this.invoicedata);
  //     params['tabevent'] = undefined;
  //     params['mode'] = this.mode;
  //     params['soGrid'] = JSON.stringify(this.data.invoiceList);
  //     params['ES'] = 'OPENORDERLIST';

  //         this.isLoading = true;
  //         this.salesservice
  //             .adduptSalesOrder(params)
  //             .then((res: any) => {
  //             });

  // }
  editInvoiceList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dcid: this.invoicedata.so_id,
      page_type: 'Open to CDC'
    };
    this.Salesservice.getcounterdcList(params).then((res: any) => {
    if(res.data.length > 0){
      this.data.invoiceList = res.data;
      this.calctotEdit();
      this.designGroupList = this.createGroup(this.data.invoiceList);
      // console.log("check for edit casee....",this.designGroupList)
      var bottom = document.querySelector("#salesTbody");
      bottom.scrollTop = bottom.scrollHeight;
    }
    });
  }
  barcodeList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dcid: this.invoicedata.dcid,
    };
    this.salesinvservice.getBarcodeOpenOrder(params).then((res: any) => {
      this.bl = res.data;
    });
  }
  oncheck(ischeck) {
    if (ischeck == true || ischeck == "true") {
      this.invoicedata.salesorder = true;
    } else {
      this.invoicedata.salesorder = false;
    }
  }

  calctot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      ftot += parseInt(this.data.invoiceList[i]["fqty"]);
      this.invoicedata.ftotal = ftot;
      htot += parseInt(this.data.invoiceList[i]["hqty"]);
      this.invoicedata.htotal = htot;
      tot += parseInt(this.data.invoiceList[i]["totqty"]);
      this.invoicedata.total = tot;
    }
  }

  calctotEdit() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      ftot += parseInt(this.data.invoiceList[i]["fqty"]);
      this.invoicedata.ftotal = ftot;
      htot += parseInt(this.data.invoiceList[i]["hqty"]);
      this.invoicedata.htotal = htot;
      tot += parseInt(this.data.invoiceList[i]["totqty"]);
      this.invoicedata.total = tot;
     
      this.updateInvoiceData(this.data.invoiceList[i], this.invoicedata)
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesOrder/openOrderConvertion.ts